import { Component, Output, EventEmitter } from '@angular/core';
import { IItem } from 'src/app/core/models/products';

@Component({
  selector: 'app-proprietary',
  templateUrl: 'proprietary.component.html',
  styleUrls: ['./proprietary.component.scss']
})
export class ProprietaryComponent {

  @Output() public sendValue = new EventEmitter<any>();

  public items: IItem[] = [];
  public showModal = false;

  public removeItem(data: number): void {
    this.items.splice(data, 1);
  }

  public openModal(): void {
    this.showModal = !this.showModal;
  }

  public sendItems(event: IItem) {
    this.items.push(event);
    this.sendValue.emit(this.items);
  }

}